module.exports={render:function (){with(this) {
  return _h('span', {
    staticClass: "ion-avatar"
  }, [_h('img', {
    attrs: {
      "src": src,
      "alt": ""
    }
  })])
}},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-28015f1c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/avatar/src/avatar.vue
// module id = 154
// module chunks = 0